import { render, staticRenderFns } from "./TokenErrorView.vue?vue&type=template&id=ffe8e13c&"
import script from "./TokenErrorView.vue?vue&type=script&lang=ts&"
export * from "./TokenErrorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports